<template>
  <div class="main_welcome">
    <el-row :gutter="24">
      <!-- 左侧：我的保单 -->
      <el-col :span="14">
        <div class="card-wrapper">
          <div class="card-header">
            <i class="el-icon-document title-icon"></i>
            <span class="card-title">我的保单</span>
          </div>
          <div class="card-content">
            <!-- 补充工伤险 -->
            <div class="policy-item">
              <div class="policy-icon">
                <img src="../assets/bcgsbx.png" alt="补充工伤险"/>
                <div class="policy-name">补充工伤险</div>
              </div>
              <div class="policy-info">
                <div v-if="bcgsshow" class="policy-detail">
                  <div class="policy-time">
                    <i class="el-icon-time time-icon"></i>
                    <span>参保时间：{{bcgsxsljlList.timeaction}} 至 {{bcgsxsljlList.timeend}}</span>
                  </div>
                  <div class="policy-status">
                    <el-tag size="small" type="success">已参保</el-tag>
                    <span class="remaining-time">剩余 {{bcgstime}} 天</span>
                  </div>
                </div>
                <div v-if="bcgsshow1" class="policy-empty">
<!--                  <i class="el-icon-warning-outline empty-icon"></i>-->
<!--                  <span class="empty-text">暂未参保</span>-->
                  <el-button type="primary" size="small" @click="ksbl('/bjgwyf')" class="enroll-btn">
                    立即参保
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 分隔线 -->
            <el-divider class="custom-divider"></el-divider>

            <!-- 补充医疗险 -->
            <div class="policy-item">
              <div class="policy-icon">
                <img src="../assets/bcylbx.png" alt="补充医疗险"/>
                <div class="policy-name">补充医疗险</div>
              </div>
              <div class="policy-info">
                <div v-if="bcylshow" class="policy-detail">
                  <div class="policy-time">
                    <i class="el-icon-time time-icon"></i>
                    <span>参保时间：{{bcylxsljlList.timeaction}} 至 {{bcylxsljlList.timeend}}</span>
                  </div>
                  <div class="policy-status">
                    <el-tag size="small" type="success">已参保</el-tag>
                    <span class="remaining-time">剩余 {{bcyltime}} 天</span>
                  </div>
                </div>
                <div v-if="bcylshow1" class="policy-empty">
<!--                  <i class="el-icon-warning-outline empty-icon"></i>-->
<!--                  <span class="empty-text"></span>-->
                  <el-button type="primary" size="small" @click="ksbl('/bcylbx_year')" class="enroll-btn">
                    立即参保
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧：快速办理 -->
      <el-col :span="10">
        <div class="card-wrapper">
          <div class="card-header">
            <i class="el-icon-lightning title-icon"></i>
            <span class="card-title">快速办理</span>
          </div>
          <div class="quick-action-content">
            <el-row :gutter="20" class="action-grid">
              <el-col :span="8" class="action-item-wrapper">
                <div class="action-item" @click="ksbl('/sljl')">
                  <div class="action-icon">
                    <img src="../assets/dyhdd.png" alt="打印核定单"/>
                  </div>
                  <div class="action-name">打印核定单</div>
                </div>
              </el-col>
              <el-col :span="8" class="action-item-wrapper">
                <div class="action-item" @click="ksbl('/insuranceClaims')">
                  <div class="action-icon">
                    <img src="../assets/bxlp.png" alt="保险理赔流程"/>
                  </div>
                  <div class="action-name">保险理赔</div>
                </div>
              </el-col>
              <el-col :span="8" class="action-item-wrapper">
                <div class="action-item" @click="ksbl('/xslpsqlc')">
                  <div class="action-icon">
                    <img src="../assets/xslpewm.png" alt="人保健康生活"/>
                  </div>
                  <div class="action-name">健康生活</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 通知公告 -->
    <div class="card-wrapper announcement-card">
      <div class="card-header">
        <i class="el-icon-bell title-icon"></i>
        <span class="card-title">通知公告</span>
        <div class="notice-count" v-if="tableData.length > 0">
          共 {{tableData.length}} 条通知
        </div>
      </div>
      <div class="announcement-content">
        <el-table
            :data="tableData"
            style="width: 100%"
            :show-header="false"
            class="announcement-table"
        >
          <el-table-column width="300">
            <template slot-scope="scope">
              <div class="notice-item">
                <i class="el-icon-chat-dot-round notice-icon"></i>
                <span class="notice-title" @click="openNotice(scope.row)">
                                    {{ scope.row.name }}
                                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="date" align="right">
            <template slot-scope="scope">
              <span class="notice-date">{{ formatDate(scope.row.date) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  data() {
    return {
      percentage: 10,
      colors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#6f7ad3',
        percentage: 100
      }],
      tableData: [],
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      dialogTableVisible3: false,
      dialogTableVisible4: false,
      bcgsshow: false,
      bcgsshow1: false,
      bcylshow: false,
      bcylshow1: false,
      bcgsxsljlList: {},
      bcylxsljlList: {},
      bcgstime: '',
      bcyltime: ''
    };
  },
  created() {
    this.user = JSON.parse(window.sessionStorage.getItem("user"));
    this.getsljlList();
    this.getbcylList();
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    openNotice(row) {
      if (row && row.url) {
        const link = document.createElement('a');
        link.setAttribute('download', row.name);
        link.setAttribute('href', encodeURI(row.url));
        link.setAttribute('target', '_blank');
        link.click();
      }
    },
    async getsljlList() {
      let moment = require('moment');
      var year = '' + moment().year();
      var formData = new FormData();
      formData.append('pageNum', 1);
      formData.append('pageSize', 20);
      formData.append('aab001', this.user.aab001);
      formData.append('year', year);
      formData.append('term', '1');

      const { data: res } = await this.$http.post("getsljlList", formData, {});
      if (res.bcgssljlList.length != 0) {
        this.bcgsxsljlList = res.bcgssljlList[0];
        this.bcgsxsljlList.timeaction = moment(this.bcgsxsljlList.timeaction).format("YYYY-MM-DD");
        this.bcgsxsljlList.timeend = moment(this.bcgsxsljlList.timeend).format("YYYY-MM-DD");

        var currentTime = moment(new Date()).add('year', 0).format("YYYY-MM-DD");
        var dateBegin = new Date(currentTime);
        var dateEnd = new Date(this.bcgsxsljlList.timeend);
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();

        this.bcgstime = Math.floor(dateDiff / (24 * 3600 * 1000));
        this.bcgsshow = true;
      } else {
        this.bcgsshow1 = true;
      }
    },
    async getbcylList() {
      let moment = require('moment');
      var year = '' + moment().year();
      var formData = new FormData();
      formData.append('pageNum', 1);
      formData.append('pageSize', 20);
      formData.append('aab001', this.user.aab001);
      formData.append('year', year);
      formData.append('term', '5');

      const {data: res} = await this.$http.post("getsljlList", formData, {});
      if (res.bcgssljlList.length != 0 && res.bcgssljlList[0].userstatus == '1') {
        this.bcylxsljlList = res.bcgssljlList[0];
        this.bcylxsljlList.timeaction = moment(res.bcgssljlList[0].timeaction).format("YYYY-MM-DD");
        this.bcylxsljlList.timeend = moment(res.bcgssljlList[0].timeend).format("YYYY-MM-DD");

        if(moment()  >  moment(res.bcgssljlList[0].spaceb)) {
          var currentTime = moment(new Date()).add('year', 0).format("YYYY-MM-DD");
          var dateBegin = new Date(currentTime);
          var dateEnd = new Date(this.bcylxsljlList.timeend);
          var dateDiff = dateEnd.getTime() - dateBegin.getTime();
          this.bcyltime = Math.floor(dateDiff / (24 * 3600 * 1000));

          this.bcylshow = true;
        } else {
          this.bcylshow1 = true;
        }
      } else {
        this.bcylshow1 = true;
      }
    },
    ksbl(urlpath) {
      this.$router.push(urlpath);
    }
  }
}
</script>

<style lang="less" scoped>
.main_welcome {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  min-height: calc(100vh - 60px);
  padding: 20px;
}

.card-wrapper {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;

  .title-icon {
    font-size: 20px;
    color: #409EFF;
    margin-right: 12px;
  }

  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -18px;
      left: 0;
      width: 40px;
      height: 3px;
      background: linear-gradient(90deg, #409EFF, #67C23A);
      border-radius: 2px;
    }
  }

  .notice-count {
    margin-left: auto;
    font-size: 14px;
    color: #909399;
  }
}

.policy-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f9fafc;
  border-radius: 8px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  .policy-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;

    img {
      width: 64px;
      height: 64px;
      object-fit: contain;
      margin-bottom: 8px;
    }

    .policy-name {
      font-size: 14px;
      color: #606266;
      font-weight: 500;
    }
  }

  .policy-info {
    flex: 1;
    margin-left: 24px;

    .policy-detail {
      .policy-time {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .time-icon {
          color: #409EFF;
          margin-right: 8px;
          font-size: 16px;
        }

        span {
          font-size: 15px;
          color: #303133;
        }
      }

      .policy-status {
        display: flex;
        align-items: center;
        gap: 16px;

        .remaining-time {
          font-size: 14px;
          color: #67C23A;
          font-weight: 500;
        }
      }
    }

    .policy-empty {
      display: flex;
      align-items: center;
      gap: 16px;

      .empty-icon {
        font-size: 20px;
        color: #E6A23C;
      }

      .empty-text {
        font-size: 16px;
        color: #606266;
      }

      .enroll-btn {
        background: linear-gradient(135deg, #409EFF, #67C23A);
        border: none;
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

.custom-divider {
  margin: 20px 0;

  /deep/ .el-divider__text {
    background: #f9fafc;
    padding: 0 16px;
    color: #909399;
    font-size: 12px;
  }
}

.quick-action-content {
  padding: 20px 0;
}

.action-grid {
  display: flex;
  justify-content: center;
}

.action-item-wrapper {
  display: flex;
  justify-content: center;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 24px 16px;
  border-radius: 12px;
  transition: all 0.3s ease;
  width: 140px;

  &:hover {
    background: #f0f7ff;
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.15);

    .action-icon {
      transform: scale(1.1);
    }

    .action-name {
      color: #409EFF;
    }
  }

  .action-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
    transition: transform 0.3s ease;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .action-name {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    text-align: center;
    transition: color 0.3s ease;
  }
}

.announcement-card {
  margin-top: 24px;
}

.announcement-content {
  /deep/ .announcement-table {
    .el-table__body-wrapper {
      .el-table__row {
        transition: background-color 0.3s ease;

        &:hover {
          background-color: #f0f7ff;

          .notice-title {
            color: #409EFF;
          }
        }
      }
    }
  }
}

.notice-item {
  display: flex;
  align-items: center;
  padding: 16px 0;

  .notice-icon {
    color: #409EFF;
    font-size: 16px;
    margin-right: 12px;
  }

  .notice-title {
    font-size: 15px;
    color: #303133;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #409EFF;
    }
  }
}

.notice-date {
  font-size: 14px;
  color: #909399;
}

// 响应式调整
@media (max-width: 1200px) {
  .el-row {
    margin-bottom: 16px;
  }

  .policy-item {
    flex-direction: column;
    text-align: center;

    .policy-icon {
      width: 100%;
      margin-bottom: 16px;
    }

    .policy-info {
      margin-left: 0;
      width: 100%;
    }
  }

  .action-grid {
    flex-wrap: wrap;
    gap: 16px;
  }

  .action-item-wrapper {
    width: 33.333%;
  }
}

@media (max-width: 768px) {
  .main_welcome {
    padding: 12px;
  }

  .card-wrapper {
    padding: 16px;
  }

  .policy-item {
    padding: 16px;

    .policy-info {
      .policy-empty {
        flex-direction: column;
        gap: 12px;
      }
    }
  }

  .action-item-wrapper {
    width: 50%;
  }
}

// 动画效果
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-wrapper {
  animation: fadeIn 0.5s ease-out;
}

.policy-item {
  animation: fadeIn 0.5s ease-out;
  animation-fill-mode: both;

  &:nth-child(1) {
    animation-delay: 0.1s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }
}
</style>
